export default {
    authenticator: { type: 'AUTHENTICATOR_APP', action: 'CONFIGURE_TOTP' },
    email: { type: 'EMAIL', action: 'CONFIGURE_EMAIL_OTP' }
}
